import React, { useState } from 'react';
import { createPayment } from '../../services/paymentService';
import { useToast } from '../../contexts/ToastContext';
interface PaystackPaymentButtonsProps {
  onSuccess?: () => void;
}
export const PaystackPaymentButtons: React.FC<PaystackPaymentButtonsProps> = ({
  onSuccess
}) => {
  const [loadingSingle, setLoadingSingle] = useState(false);
  const [loadingPro, setLoadingPro] = useState(false);
  const {
    showToast
  } = useToast();
  const handlePayment = async (planType: 'single' | 'pro') => {
    const setLoading = planType === 'single' ? setLoadingSingle : setLoadingPro;
    try {
      setLoading(true);
      // Call the Edge Function to create payment
      const {
        authorization_url
      } = await createPayment(planType);
      // Redirect to Paystack payment page
      window.location.href = authorization_url;
      // Note: onSuccess won't be called because we're redirecting away
      // Success handling happens on the callback page after payment
    } catch (error) {
      console.error('Payment error:', error);
      showToast('Payment server busy, try again.', 'error');
      setLoading(false);
    }
  };
  return <div className="space-y-4" data-id="element-1559">
      {/* Single Scan - $2.99 */}
      <button onClick={() => handlePayment('single')} disabled={loadingSingle || loadingPro} className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-4 px-6 rounded-xl font-semibold text-lg hover:from-purple-700 hover:to-pink-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl" data-id="element-1560">
        {loadingSingle ? <span className="flex items-center justify-center" data-id="element-1561">
            <svg className="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24" data-id="element-1562">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-1563" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-1564" />
            </svg>
            Processing...
          </span> : <>Unlock 1 Scan - $2.99</>}
      </button>

      {/* Pro Plan - $9.99 */}
      <button onClick={() => handlePayment('pro')} disabled={loadingSingle || loadingPro} className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 px-6 rounded-xl font-semibold text-lg hover:from-blue-700 hover:to-indigo-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl" data-id="element-1565">
        {loadingPro ? <span className="flex items-center justify-center" data-id="element-1566">
            <svg className="animate-spin h-5 w-5 mr-2" viewBox="0 0 24 24" data-id="element-1567">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-1568" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-1569" />
            </svg>
            Processing...
          </span> : <>Go Pro - $9.99/month</>}
      </button>
    </div>;
};